angular
  .module('deskfy.arts')
  .controller('UserSearchBarController', UserSearchBarController)

export const CUSTOMIZATION_LEVEL = {
  FREE_STYLE: 'FREE_STYLE',
  RESTRICTED: 'RESTRICTED',
  READY_TO_USE: 'READYTOUSE',
  ONLY_DOWNLOAD: 'ONLY_DOWNLOAD'
}

/* @ngInject */
function UserSearchBarController ($scope, $translate, $timeout, TagsService, FormatsService, ToastService, SegmentService, CampaignService) {
  const api = {
    _onFilter,
    _onSearch,
    _loadFormats,
    _trackFiltersUsage,
    _initFilters,
    _initFilterTags,
    _initAdvancedFilters,
    _handleFiltersChange,
    _normalizeFixedTags,
    _normalizeDynamicTags,
    _getCampaignOptionsAndValue,
    _updateActiveAndSelectedFilters,
    _setFormatsOptionsAndSelectedValue,
    _setNeedApprovalOptionsAndSelectedValue,
    _setCustomizationLevelOptionsAndSelectedValue
  }
  this.getApi = () => api

  $scope.formats = {
    state: {
      loading: true
    },
    pagination: {
      top: 10
    },
    results: []
  }
  $scope.selectedFilters = {
    query: null,
    formatIds: [],
    campaignId: null,
    needApproval: null,
    customizationLevel: null
  }
  $scope.headerToolbar = {
    search: {
      value: undefined,
      filters: [],
      onFilter: api._onFilter,
      onSearch: api._onSearch
    }
  }

  activate()
  function activate () {
    api._loadFormats()
  }

  const deregisterfiltersWatcher = $scope.$watch('selectedFilters', (newValue, oldValue) => {
    if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return
    api._handleFiltersChange()
    api._updateActiveAndSelectedFilters()
  }, true)

  /**
   * Listen to reset event.
   */
  const deregisterResetWatcher = $scope.$on('user-search-bar.reset', () => {
    $scope.selectedFilters = {
      query: null,
      formatIds: [],
      campaignId: null,
      needApproval: null,
      customizationLevel: null
    }
    $scope.headerToolbar.search.value = undefined
  })

  $scope.$on('$destroy', function () {
    deregisterResetWatcher()
    deregisterfiltersWatcher()
  })

  $scope.getTagType = (filter) => {
    if (filter.disabled) return 'default'
    if (filter.active) return 'clear'
    return 'add'
  }

  $scope.getTagColor = (filter) => {
    if (filter.active) return 'blue'
    return 'gray'
  }

  $scope.handleTagsClick = function (key, value) {
    try {
      const currentValue = $scope.selectedFilters[key]

      /**
       * Multiple values.
       */
      if (Array.isArray(currentValue)) {
        const includedValue = currentValue.includes(value)
        if (includedValue) {
          $scope.selectedFilters[key] = currentValue.filter(currentValue => currentValue !== value)
          return
        }

        $scope.selectedFilters[key].push(value)
        api._trackFiltersUsage(key, value)
        return
      }

      /**
       * Toggle value.
       */
      if (currentValue === value) {
        $scope.selectedFilters[key] = null
        return
      }

      $scope.selectedFilters[key] = value
      api._trackFiltersUsage(key, value)
    } catch (error) {
      ToastService.showErrorToast($translate.instant('userArts.filters.error'))
      console.error({ error })
    }
  }

  $scope.onBreadcrumbsClick = (event) => {
    if ($scope.breadcrumbs?.onChange) $scope.breadcrumbs.onChange(event.detail)
  }

  function _initFilters () {
    api._initFilterTags()
    api._initAdvancedFilters()
  }

  function _initFilterTags () {
    api._normalizeFixedTags()
    api._normalizeDynamicTags()
  }

  function _initAdvancedFilters () {
    const customizationLevelOptions = [
      {
        icon: 'lock',
        label: $translate.instant('readyToUse'),
        value: CUSTOMIZATION_LEVEL.READY_TO_USE,
        active: $scope.selectedFilters.customizationLevel === CUSTOMIZATION_LEVEL.READY_TO_USE,
        disabled: false
      },
      {
        icon: 'lock-filled',
        label: $translate.instant('userArts.arts.customizable'),
        value: CUSTOMIZATION_LEVEL.FREE_STYLE,
        active: $scope.selectedFilters.customizationLevel === CUSTOMIZATION_LEVEL.FREE_STYLE,
        disabled: false
      }
    ]

    const approvalOptions = [
      {
        icon: 'check',
        label: $translate.instant('withApproval'),
        value: true,
        active: $scope.selectedFilters.needApproval === true,
        disabled: false
      },
      {
        icon: 'close',
        label: $translate.instant('withoutApproval'),
        value: false,
        active: $scope.selectedFilters.needApproval === false,
        disabled: false
      }
    ]

    const filters = [
      {
        name: 'customizationLevel',
        type: 'FILTER_BUTTON_SELECT',
        value: null,
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('customizationLevel'),
          multiple: false,
          switchMode: false,
          udsDisabled: false,
          options: customizationLevelOptions
        }
      },
      {
        name: 'needApproval',
        type: 'FILTER_BUTTON_SELECT',
        value: null,
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('templates'),
          multiple: false,
          switchMode: false,
          udsDisabled: false,
          options: approvalOptions
        }
      },
      {
        name: 'tagIds',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          type: 'tag',
          label: $translate.instant('filterByTags'),
          options: [],
          emptyMsg: $translate.instant('noResults'),
          placeholder: $translate.instant('selectPlaceholder'),
          udsDisabled: false,
          hasMoreOptions: false,
          loadButtonLabel: ''
        },
        loadData: (name, top, skip) => TagsService.getTags({ name, top, skip })
      },
      {
        name: 'campaignId',
        type: 'INPUT_SELECT',
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('campaignsModule.single'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          pricing: false,
          pricingTooltip: '',
          pricingTooltipPosition: 'top',
          options: []
        },
        loadData: (search, top, skip) => CampaignService.getAllCampaigns({ search, top, skip, isArchived: false })
      },
      {
        name: 'formatIds',
        type: 'INPUT_MULTISELECT',
        defaultValue: [],
        props: {
          type: 'tag',
          label: $translate.instant('product'),
          options: [],
          emptyMsg: $translate.instant('noResults'),
          placeholder: $translate.instant('selectPlaceholder'),
          udsDisabled: false,
          hasMoreOptions: false,
          loadButtonLabel: ''
        },
        loadData: (search, top, skip) => FormatsService.getMostUsedFormats({ search, top, skip })
      }
    ].filter(Boolean)

    $timeout(() => {
      $scope.headerToolbar.search.filters = filters
    }, 0)
  }

  function _normalizeFixedTags () {
    $timeout(() => {
      $scope.headerFixedTagsToolbar = [
        {
          key: 'customizationLevel',
          label: $translate.instant('readyToUse'),
          value: CUSTOMIZATION_LEVEL.READY_TO_USE,
          active: $scope.selectedFilters.customizationLevel === CUSTOMIZATION_LEVEL.READY_TO_USE,
          disabled: false
        },
        {
          key: 'customizationLevel',
          label: $translate.instant('userArts.arts.customizable'),
          value: CUSTOMIZATION_LEVEL.FREE_STYLE,
          active: $scope.selectedFilters.customizationLevel === CUSTOMIZATION_LEVEL.FREE_STYLE,
          disabled: false
        },
        {
          key: 'needApproval',
          label: $translate.instant('withApproval'),
          value: true,
          active: $scope.selectedFilters.needApproval === true,
          disabled: false
        },
        {
          key: 'needApproval',
          label: $translate.instant('withoutApproval'),
          value: false,
          active: $scope.selectedFilters.needApproval === false,
          disabled: false
        }
      ]
    }, 0)
  }

  function _normalizeDynamicTags () {
    $timeout(() => {
      $scope.headerDynamicTagsToolbar = $scope.formats?.results?.map(format => ({
        key: 'formatIds',
        label: format.name,
        value: format.id,
        active: Array.isArray($scope.selectedFilters.formatIds) && $scope.selectedFilters.formatIds.includes(+format.id),
        disabled: false
      }))
    }, 0)
  }

  function _handleFiltersChange () {
    if (!$scope.onFilterChange) return
    const filters = $scope.selectedFilters
    const normalizedFilter = Object.keys(filters).reduce((accumulator, filterKey) => {
      const filterIsArrayButHasNoValue = (Array.isArray(filters[filterKey]) && !filters[filterKey]?.length)
      const filterHasNoValue = filters[filterKey] === null || filters[filterKey] === undefined || filterIsArrayButHasNoValue
      if (filterHasNoValue) return accumulator

      const getValue = () => {
        const filterOriginalValue = filters[filterKey]
        if (filterKey === 'customizationLevel') {
          if (filters[filterKey] === CUSTOMIZATION_LEVEL.READY_TO_USE) return [CUSTOMIZATION_LEVEL.ONLY_DOWNLOAD]
          return [CUSTOMIZATION_LEVEL.RESTRICTED, CUSTOMIZATION_LEVEL.FREE_STYLE]
        }

        if (Array.isArray(filterOriginalValue)) return filterOriginalValue.filter(Boolean)
        return filterOriginalValue
      }

      return { ...accumulator, [filterKey]: getValue() }
    }, {})

    $scope.onFilterChange({ filters: normalizedFilter })
  }

  function _loadFormats () {
    $scope.formats.state.loading = true
    FormatsService.getMostUsedFormats({
      top: $scope.formats.pagination.top
    })
      .then(res => { $scope.formats.results = (res?.rows ?? []); api._initFilters() })
      .catch(() => ToastService.showErrorToast($translate.instant('userArts.formats.error')))
      .finally(() => { $scope.formats.state.loading = false })
  }

  /**
   * On user apply the filter.
   * @param {Object} filter
   */
  function _onFilter (filter) {
    $timeout(() => {
      $scope.selectedFilters.tagIds = [...new Set([...(filter?.tagIds ?? [])])]
      $scope.selectedFilters.formatIds = [...new Set([...(filter?.formatIds ?? [])])]
      $scope.selectedFilters.campaignId = filter?.campaignId ?? null
      $scope.selectedFilters.needApproval = filter?.needApproval ?? null
      $scope.selectedFilters.customizationLevel = filter?.customizationLevel ?? null
    }, 100)
  }

  /**
   * On user type on search input.
   * Delay update to avoid multiple api calls and trackings.
   * @param {String} search
   */
  function _onSearch (search) {
    $timeout(() => {
      $scope.selectedFilters.query = search?.length ? search : undefined
    }, 700)
  }

  /**
   * Handle track event of quick filters.
   * @param {string} key Key of selected tag.
   * @param {number} value Value of selected tag.
   * @returns
   */
  function _trackFiltersUsage (key, value) {
    const trackEvents = {
      formatIds: (value) => {
        if (!value) return
        const foundFormat = $scope.formats.results.find(format => format.id === value)
        if (!foundFormat) return
        SegmentService.track('arts-filter-btn', { format: foundFormat.name })
      },
      needApproval: (value) => {
        if (typeof value === 'undefined') return
        SegmentService.track('arts-filter-btn', { type: value ? 'approval' : 'no_approval' })
      },
      customizationLevel: (value) => {
        if (typeof value === 'undefined') return
        SegmentService.track('arts-filter-btn', { type: value === CUSTOMIZATION_LEVEL.READY_TO_USE ? 'download_only' : 'customizable' })
      }
    }

    const filterIsArrayButHasNoValue = Array.isArray(value) && !value?.length
    const filterHasNoValue = value === null || value === undefined || filterIsArrayButHasNoValue
    if (filterHasNoValue) return
    const foundTrackEvent = trackEvents[key]
    if (foundTrackEvent) foundTrackEvent(value)
  }

  function _updateActiveAndSelectedFilters () {
    this._initFilterTags()

    const filterActions = {
      formatIds: _setFormatsOptionsAndSelectedValue,
      campaignId: _setCampaignIdOptionsAndSelectedValue,
      needApproval: _setNeedApprovalOptionsAndSelectedValue,
      customizationLevel: _setCustomizationLevelOptionsAndSelectedValue
    }

    $timeout(() => {
      for (const filter of $scope.headerToolbar.search.filters) {
        const filterAction = filterActions[filter.name]
        if (filterAction) filterAction(filter)
      }
    }, 0, true)
  }

  function _setCampaignIdOptionsAndSelectedValue (filter) {
    const selectedCampaign = api._getCampaignOptionsAndValue(filter)
    filter.value = selectedCampaign
  }

  function _getCampaignOptionsAndValue (filter) {
    const selectedFilters = $scope.selectedFilters
    const campaignHasNoSelectedValue = !selectedFilters.campaignId
    if (campaignHasNoSelectedValue) return null

    const selectedCampaign = filter.props.options?.find(campaign => campaign.value === selectedFilters.campaignId)
    if (!selectedCampaign) return null

    return {
      label: selectedCampaign.label,
      value: selectedCampaign.value,
      active: true,
      disabled: false
    }
  }

  function _setNeedApprovalOptionsAndSelectedValue (filter) {
    const selectedFilters = $scope.selectedFilters
    const [withApprovalOption, withoutApprovalOption] = filter.props.options
    const getNeedApprovalActiveValue = () => {
      if (selectedFilters?.needApproval === true) return { ...withApprovalOption, active: true }
      if (selectedFilters?.needApproval === false) return { ...withoutApprovalOption, active: true }
      return null
    }
    const selectedValue = getNeedApprovalActiveValue()
    const needApprovalOptions = [
      { ...withApprovalOption, active: selectedFilters?.needApproval === true },
      { ...withoutApprovalOption, active: selectedFilters?.needApproval === false }
    ]

    filter.value = selectedValue
    filter.options = needApprovalOptions
  }

  function _setCustomizationLevelOptionsAndSelectedValue (filter) {
    const selectedFilters = $scope.selectedFilters
    const [readyToUseOption, freeStyleOption] = filter.props.options
    const getCustomizationLevelActiveValue = () => {
      if (selectedFilters?.customizationLevel === CUSTOMIZATION_LEVEL.FREE_STYLE) return { ...freeStyleOption, active: true }
      if (selectedFilters?.customizationLevel === CUSTOMIZATION_LEVEL.READY_TO_USE) return { ...readyToUseOption, active: true }
      return null
    }
    const selectedValue = getCustomizationLevelActiveValue()
    const customizationLevelOptions = [
      { ...readyToUseOption, active: $scope.selectedFilters.customizationLevel === CUSTOMIZATION_LEVEL.READY_TO_USE },
      { ...freeStyleOption, active: $scope.selectedFilters.customizationLevel === CUSTOMIZATION_LEVEL.FREE_STYLE }
    ]

    filter.value = selectedValue
    filter.options = customizationLevelOptions
  }

  function _setFormatsOptionsAndSelectedValue (filter) {
    const selectedFilters = $scope.selectedFilters
    const getFormatOptionsAndValue = () => {
      const formatsHasNoSelectedValueOrResults = !selectedFilters.formatIds?.length || !$scope.formats.results?.length
      if (formatsHasNoSelectedValueOrResults) return []
      return $scope.formats.results
        .filter(format => {
          const isFormatSelected = selectedFilters.formatIds.includes(format.id)
          return isFormatSelected
        })
        .map(format => ({
          label: format.name,
          value: format.id,
          active: true,
          disabled: false
        }))
    }

    const selectedFormats = getFormatOptionsAndValue() || []
    filter.value = selectedFormats
    filter.props.options = selectedFormats
  }
}
export { UserSearchBarController }
